import styled from 'styled-components';

var StaticLoadingWrapper = styled.div.withConfig({
  displayName: "styles__StaticLoadingWrapper",
  componentId: "sc-ntgcom-0"
})(["width:", ";height:", ";margin:0 auto;"], function (props) {
  return props.size + 'px';
}, function (props) {
  return props.size + 'px';
}); // Required to compensate for the minor padding around all of our icons

var IconWrapper = styled.div.withConfig({
  displayName: "styles__IconWrapper",
  componentId: "sc-ntgcom-1"
})(["& > svg{transform:scale(1.2);}"]);

export { IconWrapper, StaticLoadingWrapper };
